module.exports = __webpack_public_path__ + "static/media/accenture-julie-sweet.09b6ddd8.png";